// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","316":"1cdc7ba1","455":"492e6b75","578":"4c46475d","977":"5d9c67ca"}[chunkId] + ".chunk.js";
};